<template>
  <div class="service-wrap">
    <Header :title="'注册协议'" />
    <div class="service">
      <h5>{{ title }}</h5>
      <div class="txt" v-html="content" />
    </div>
  </div>
</template>
<script>
import { getSinglepage } from '@/api/Comm'
import { Toast } from '@nutui/nutui'
import Header from '@/components/Header/Index'

export default {
  name: 'Service',
  components: {
    Header
  },
  data() {
    return {
      code: 'Register',
      title: '',
      content: ''
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      getSinglepage(this.code).then(res => {
        if (res && res.success) {
          this.content = res.data.content
          this.title = res.data.title
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    toggle() {
      this.$emit('revice')
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/styles/index.scss';

.service-wrap {
  width: 100vw;
  min-height: 100vh;
  height: auto;
  // background-image: url('~@/assets/images/bg-service.webp');
  background-image: url('~@/assets/images/bg-service.png');
  background-size: 100%;
  background-position: bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
  padding: 23px 15px 132px 15px;

  .service {
    width: 100%;
    height: auto;
    min-height: 0;
    overflow: hidden;
    background: #ffffff;
    box-sizing: border-box;
    padding: 15px 15px 35px 15px;
    font-size: 12px;
    color: #626262;
    border-radius: 5px;
    @extend %boxShadow;

    h5 {
      font-size: 16px;
      color: #4c4c4c;
      margin: 0;
      padding: 0;
      line-height: 40px;
      text-align: center;
    }

    .txt {
      width: 100%;
      min-height: 0;
      height: auto;
      overflow: hidden;

      img {
        max-width: 100%;
      }
    }
  }

  .header {
    position: fixed;
    z-index: 100;
    left: 0;
    right: 0;
    top: 0;
    height: 35px;
    background: #ededed;
    border-bottom: 1px solid #eee;

    .left {
      position: absolute;
      left: 15px;

      i {
        font-size: 16px;
        color: #000;
      }
    }

    .title {
      color: #000;
      font-size: 14px;
    }

    &.no-border {
      border-bottom: none;
    }
  }

  .pad {
    padding-bottom: 36px;
  }
}
</style>
